import { match } from "ts-pattern";
import { ProductPermission, StudioPermission, } from "@biggeo/bg-server-lib/studio";
export const BIG_GEO_SUPPORT_EMAIL = "support@biggeo.com";
export const SAVED_AREAS_CREATION_LIMIT = 50;
export const SAVED_VIEWS_CREATION_LIMIT = 50;
export var BillingEventName;
(function (BillingEventName) {
    BillingEventName["BG_VELOCITY_CHARGE"] = "BG_VELOCITY_CHARGE";
})(BillingEventName || (BillingEventName = {}));
export const productPrice = {
    [BillingEventName.BG_VELOCITY_CHARGE]: 5000,
};
export const BG_GENERATE_ID_NAME = "BG_ID";
var DownloadType;
(function (DownloadType) {
    DownloadType["files"] = "files";
    DownloadType["folders"] = "folders";
})(DownloadType || (DownloadType = {}));
var CloudStorageType;
(function (CloudStorageType) {
    CloudStorageType["Aws"] = "Aws";
    CloudStorageType["Azure"] = "Azure";
    CloudStorageType["Sf"] = "Sf";
    CloudStorageType["Gcp"] = "Gcp";
    CloudStorageType["Upload"] = "Upload";
})(CloudStorageType || (CloudStorageType = {}));
var FileType;
(function (FileType) {
    FileType["csv"] = "csv";
    FileType["parquet"] = "parquet";
    FileType["shp"] = "shp";
    FileType["unsupported"] = "unsupported";
})(FileType || (FileType = {}));
export const CSV_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/csvFileIcon.png";
export const PARQUET_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/ParquetFileIcon.png";
export const SHAPEFILE_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/ShapefileFileIcon.png";
export const UNSUPPORTED_FILE_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/Files%20Icons.png";
export const AWS_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/AwsAvatar.png";
export const AZURE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/AzureAvatar.png";
export const STRIPE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/StripeLogo.png";
export const SNOWFLAKE_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/sf.png";
export const DATALAB_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/Datalab_Icon.png";
export const GCP_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/GCP_LOGO.png";
export const SELLER_PROGRAM_IMAGE = "https://sabiggeomedia01.blob.core.windows.net/media/SellerProgram.png";
export const NO_ACCESS_KEYS_FEATURE_IMAGE = "https://sabiggeomedia01.blob.core.windows.net/media/NoAccessKeysFeature.png";
export const NO_ADD_DATASOURCE_FEATURE_IMAGE = "https://sabiggeomedia01.blob.core.windows.net/media/NoAddDatasourceFeature.png";
export const UPLOAD_LOGO = "https://sabiggeomedia01.blob.core.windows.net/media/2025-04-29T22%3A03%3A04-Icon.png";
export const BG_MARKETPLACE_CIRCULAR_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/MarketplaceCircularIcon.png";
export const FILES_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/Files%20Icons.png";
export const FOLDERS_ICON = "https://sabiggeomedia01.blob.core.windows.net/media/folderIcons.png";
export const BG_FACE_ID = "BG_FACE_ID";
export const cloudFullName = {
    [CloudStorageType.Aws]: "Amazon Web Services",
    [CloudStorageType.Azure]: "Microsoft Azure",
    [CloudStorageType.Sf]: "Snowflake",
    [CloudStorageType.Gcp]: "Google Cloud Platform",
    [CloudStorageType.Upload]: "Upload",
};
export const matchCloudStorageTypeWithIcon = (cloudStorageType) => {
    return match(cloudStorageType)
        .with(CloudStorageType.Aws, () => AWS_LOGO)
        .with(CloudStorageType.Azure, () => AZURE_LOGO)
        .with(CloudStorageType.Sf, () => SNOWFLAKE_LOGO)
        .with(CloudStorageType.Gcp, () => GCP_LOGO)
        .with(CloudStorageType.Upload, () => UPLOAD_LOGO)
        .exhaustive();
};
export const fileIconMap = {
    [FileType.csv]: CSV_FILE_ICON,
    [FileType.parquet]: PARQUET_FILE_ICON,
    [FileType.unsupported]: UNSUPPORTED_FILE_ICON,
    [FileType.shp]: SHAPEFILE_FILE_ICON,
};
export const logoMap = {
    [CloudStorageType.Aws]: AWS_LOGO,
    [CloudStorageType.Azure]: AZURE_LOGO,
    [CloudStorageType.Sf]: SNOWFLAKE_LOGO,
    [CloudStorageType.Gcp]: GCP_LOGO,
    [CloudStorageType.Upload]: UPLOAD_LOGO,
};
const isType = (value, validValues) => {
    return validValues.includes(value);
};
export const getFileIcon = (value) => {
    if (isType(value, Object.values(FileType))) {
        return fileIconMap[value];
    }
    return UNSUPPORTED_FILE_ICON;
};
export const getLogoIcon = (value) => {
    if (isType(value, Object.values(CloudStorageType))) {
        return logoMap[value];
    }
    return UPLOAD_LOGO;
};
export const downloadTypeIconMap = {
    [DownloadType.files]: FILES_ICON,
    [DownloadType.folders]: FOLDERS_ICON,
};
export const ADMIN_STUDIO_PERMISSION = [
    StudioPermission.dataManagement,
    StudioPermission.licenseManagement,
    StudioPermission.marketplace,
    StudioPermission.productManagement,
    StudioPermission.recipeManagement,
    StudioPermission.settings,
    StudioPermission.teamManagement,
];
export const ADMIN_PRODUCT_PERMISSION = [
    ProductPermission.dataLab,
    ProductPermission.datascapeAi,
    ProductPermission.imagery,
    ProductPermission.simulate,
];
//# sourceMappingURL=constants.js.map